import { Controller } from "stimulus"
import { showToast } from './../../support/toast.js';

export default class extends Controller {
  static targets = ["urls", "generate", "processing", "closeButton", "form"]

  initialize() {
    let self = this;

    let generate = $(self.generateTargets);
    let processing = $(self.processingTargets);
    let closeButton = $(self.closeButtonTargets);
    let modalInstance = FlowbiteInstances.getInstance('Modal', self.element.id);

    generate[0].onclick = () => {
      var token = document.getElementsByName('csrf-token')[0].content
      generate.hide();
      closeButton.hide();
      processing.show();

      $.ajax({
        url: self.formTarget.action,
        type: 'POST',
        data: {
          urls: self.urlsTargets.map(input => input.value),
          identifier: self.element.dataset.identifier
        },
        headers: {
            'X-CSRF-Token': token
        },
        success: function(response) {
          let checkUrl = self.formTarget.dataset.checkUrl;
          let interval = setInterval(() => {
            $.get(checkUrl + "?jid=" + response["jid"], function(data) {
              if (data['status'] == 'complete') {
                $("#task_ai_guideline_description").val(data['description']);
                $("#task_ai_guideline_name").val(data['title']);

                clearInterval(interval);

                modalInstance.hide();
                generate.show();
                closeButton.show();
                processing.hide();
              } else if(data['status'] == 'failed') {
                // parse the errors as json
                let errors = JSON.parse(data['errors']);
                clearInterval(interval);
                if(errors.length > 0) {
                  $.each(errors, function(index, value) {
                    showToast(value, 'danger');
                  });
                } else {
                  showToast('Something went wrong', 'danger');
                }

                modalInstance.hide();
                generate.show();
                closeButton.show();
                processing.hide();
              }
            });
          }, 1000);
        }
      });
    }
  }
}